import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import cookies from "./util.cookies";
import db from "./util.db";
import log from "./util.log";
var util = {
  cookies: cookies,
  db: db,
  log: log
};

/**
 * @description 更新标题
 * @param {String} title 标题
 */
util.title = function (titleText) {
  var processTitle = process.env.VUE_APP_TITLE || "D2Admin";
  window.document.title = "".concat(processTitle).concat(titleText ? " | ".concat(titleText) : "");
};

/**
 * @description 打开新页面
 * @param {String} url 地址
 */
util.open = function (url) {
  var a = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("target", "_blank");
  a.setAttribute("id", "d2admin-link-temp");
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(document.getElementById("d2admin-link-temp"));
};
util.thumb = function (src, w, h) {
  w = w || 200;
  h = h || w || 200;
  return src + "?imageView2/0/w/" + w + "/h/" + h;
};
util.uuid = function () {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 32; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";
  var uuid = s.join("");
  return uuid;
};
util.isProduction = function () {
  if (process.browser) {
    if (location.hostname == "localhost") {
      return false;
    } else if (location.hostname == "devcong.wellcee.com") {
      return false;
    } else if (location.hostname == "devvvv.wellcee.com") {
      return false;
    } else if (location.hostname == "www.wellcee.com") {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};
util.fillZero = function (number) {
  if (!number) {
    return 0;
  }
  if (number < 10) {
    return "0".concat(number);
  }
  return number;
};
export default util;